import { render, staticRenderFns } from "./ServiceCode.vue?vue&type=template&id=0ff1e304&scoped=true&"
import script from "./ServiceCode.vue?vue&type=script&lang=js&"
export * from "./ServiceCode.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCode.vue?vue&type=style&index=0&id=0ff1e304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff1e304",
  null
  
)

export default component.exports